// Note that the collection is extended from an array.
// However be careful when iterating through the properties as we may have added additional properties which will also be iterated over.

import OnlineAppCollection from "./online_app_collection";
import MapFilter from "../models/map_filter";
import Subpage from "../models/subpage";

export default class NavOptionCollection extends OnlineAppCollection {

    constructor(onlineApp=null,...items) {
        super(onlineApp, ...items);
    }

    allWithAnyMapFilter() {
        if (this.isEmpty()) { return [] }
        return this.filter( item => item.mapFilter instanceof MapFilter );
    }

    allWithAnySubpage() {
        if (this.isEmpty()) { return [] }
        return this.filter( item => item.subpage instanceof Subpage );
    }

}